import { APIGATEWAY_BASE_URL } from 'src/dataLayer/env'
import { NO_CAPTCHA_REQUIRED_STATUS } from 'src/dataLayer/localData/captcha.js'
import makeAjaxRequest from 'src/dataLayer/remoteData/babbelAPI/makeAjaxRequest'

const ERROR_KEYS = {
  400: {
    key: 'common.error.unknown',
  },
  422: {
    key: 'email.error.restricted_magic_link',
  },
  default: {
    key: 'common.error.unknown',
  },
}

const getPayload = ({ captchaResponseToken, email }) => {
  const payload = {
    account: {
      captcha: {
        token: captchaResponseToken === NO_CAPTCHA_REQUIRED_STATUS ? '' : captchaResponseToken,
      },
      email,
    },
  }
  return payload
}

export default (properties) =>
  makeAjaxRequest({
    errorKeys: ERROR_KEYS,
    payload: getPayload(properties),
    url: `${APIGATEWAY_BASE_URL}/v1.0.0/${properties.locale}/authentication/magic_link`,
    verb: 'POST',
  })
    .then((response) => response)
    .catch((error) => ({ error }))

export { ERROR_KEYS }
